import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbNavModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPaginationModule } from "ngx-pagination";
import { PaginationComponent } from "./pagination/pagination.component";
import { TranslateModule } from "@ngx-translate/core";
import { AppliedFilterDetailsComponent } from "./applied-filter-details/applied-filter-details.component";
import { PipesModule } from "../pipes/pipes.module";
import { ChatComponent } from "./chat/chat.component";
import { BookingInvoiceComponent } from "./booking-invoice/booking-invoice.component";
import { DatePickerComponent } from "./date-picker/date-picker.component";
import { FlatpickrModule } from "angularx-flatpickr";
import { FormsModule } from "@angular/forms";
import { LightboxModule } from "ngx-lightbox";

@NgModule({
  declarations: [PaginationComponent, AppliedFilterDetailsComponent, ChatComponent, BookingInvoiceComponent, DatePickerComponent],
  imports: [
    // Chat attachments open full size in the lightbox; declared here rather than relying on
    // PagesModule happening to import it, since ChatComponent lives in this module.
    LightboxModule,CommonModule, NgbNavModule, NgbDropdownModule, FormsModule, NgxPaginationModule, TranslateModule, PipesModule, FlatpickrModule.forRoot()],
  exports: [PaginationComponent, AppliedFilterDetailsComponent, ChatComponent, BookingInvoiceComponent, DatePickerComponent]
})
export class SharedComponentsModule {}
